import type { JSX } from 'react';
import styles from '../ApprovalPortalPage.module.css';

interface ApprovalActionsProps {
  isApproved: boolean | null;
  approvalStatus: 'idle' | 'approving' | 'success' | 'error';
  onApprove: (approved: boolean) => void;
}

export const ApprovalActions = ({
  isApproved,
  approvalStatus,
  onApprove,
}: ApprovalActionsProps): JSX.Element => (
  <div className={styles.reviewActions}>
    <div className={styles.reviewActionsRow}>
      <button
        className={`${styles.approveBtn} ${isApproved === true ? styles.approveBtnDone : ''}`}
        disabled={isApproved === true}
        onClick={() => isApproved !== true && onApprove(true)}
      >
        {approvalStatus === 'approving'
          ? 'Saving…'
          : isApproved === true
            ? '✓ Approved'
            : 'Approve'}
      </button>
      <button
        className={`${styles.rejectBtn} ${isApproved === false ? styles.rejectBtnDone : ''}`}
        disabled={isApproved === false}
        onClick={() => isApproved !== false && onApprove(false)}
      >
        {isApproved === false ? '✕ Rejected' : 'Reject'}
      </button>
    </div>
    {approvalStatus === 'success' && (
      <span className={styles.successMsg}>Saved</span>
    )}
    {approvalStatus === 'error' && (
      <span className={styles.errorMsg}>Failed — try again</span>
    )}
  </div>
);
